import { Routes, Route } from 'react-router-dom';
import { ToastProvider } from './contexts/ToastContext';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './pages/HomePage';
import InvitePage from './pages/InvitePage';
import StoryPage from './pages/StoryPage';
import AdminPage from './pages/AdminPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import './App.css';

const App = () => (
  <ToastProvider>
    <AuthProvider>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/invite/:id" element={<InvitePage />} />
        <Route path="/invite/:id/story" element={<StoryPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route
          path="/admin"
          element={(
            <ProtectedRoute>
              <AdminPage />
            </ProtectedRoute>
          )}
        />
      </Routes>
    </AuthProvider>
  </ToastProvider>
);

export default App;
